// extracted by mini-css-extract-plugin
export default {"root":"_3PyYhTCHGM2u2oS7wpGJNR","searchParamLabel":"_4EVV4lSwN9F4txFMWYD13m","submitSearchButton":"_4cPOfC6CFu1Paf3A1K4DsD button success"};